<template>
  <footer class="app-footer text-center">
    <p class="h6">Privacy Policy | Terms of Service | Web Accessibility</p>
    <p class="h6">© 2025 Psyncopate, Inc. All rights reserved. | UI Version: {{ guiVersion }}</p>
  </footer>
</template>

<script>
import { pageViews } from "@/utils/util";
// Use require with the correct relative path
const packageJson = require("../../../package.json");

export default {
  name: pageViews.FOOTERVIEW,
  data() {
    return {
      guiVersion: packageJson.guiVersion, // Dynamically use the GUI version
    };
  },
};
</script>

<style scoped>
.app-footer {
  /* margin-top: auto; */
  background:var(--surface-hover);
  border-top: 2px solid color-mix(in srgb, var(--primary) 30%, transparent);
  color: var(--text-secondary);
  text-align: center;
  font-family: "Inter", sans-serif;
  width: 100%;
  transition: all 0.3s ease;
  position: relative;
  z-index: 10;
  animation: fadeUp 0.5s ease-in-out;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

body {
  padding-bottom: 70px; /* adjust for footer height */
}


/* Hover glow effect */
.app-footer:hover {
  background: linear-gradient(145deg, var(--primary-bg), var(--surface));
}

/* Text styles */
.app-footer p {
  margin: 4px 0;
  font-size: 13.5px;
  color: var(--text-primary);
  letter-spacing: 0.2px;
  transition: color 0.3s ease;
}

/* Hover links (like Privacy Policy, etc.) */
.app-footer p:hover {
  color: var(--primary);
  cursor: pointer;
}

/* Highlight separator (first paragraph) */
.app-footer p:first-of-type {
  color: var(--primary);
  font-weight: 500;
}

.app-footer .h6 {
  margin: 6px 0;
  font-weight: 500;
}


.app-footer:hover::before {
  opacity: 0.9;
}

/* Animation */
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive tweaks */
@media (max-width: 768px) {
  .app-footer p {
    font-size: 12.5px;
  }
}

/* === DARK MODE === */
[data-theme="dark"] .app-footer {
  background: var(--surface-hover);
  border-top: 2px solid color-mix(in srgb, var(--primary) 35%, transparent);
}

</style>



